// extracted by css-extract-rspack-plugin
module.exports =  {"title":"DocumentManualVerificationModal__title___mydkH","viewDocumentLink":"DocumentManualVerificationModal__viewDocumentLink___UPJyZ"};